import { render, staticRenderFns } from "./UploadCsv.vue?vue&type=template&id=60a0f607&scoped=true&"
import script from "./UploadCsv.vue?vue&type=script&lang=js&"
export * from "./UploadCsv.vue?vue&type=script&lang=js&"
import style0 from "./UploadCsv.vue?vue&type=style&index=0&id=60a0f607&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a0f607",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VLayout})
